import { typeStrategy } from "../constants/typeStrategy.constant";
import { GeoData, GeoItem, GeoOption } from "../types/geoGeoable";

export class GeoTransformers {
  static mapToGeo: () => (items?: GeoItem[]) => any[] = () => {
    return (items?: GeoItem[]) => items?.map(this.geoItemTransformer) || [];
  };

  static geoItemTransformer: (item: GeoItem) => GeoOption | void = (item: GeoItem) => {
    if (!item || !item.geo) {
      return;
    }

    const { geo, geo_type } = item;

    const isCity = geo_type as keyof typeof typeStrategy === 'Geo::City';

    const label = (
      <p>
        {geo.display_name}
        {isCity && geo.state.acronym ? `/${geo.state.acronym}` : ''}

        <span className="italic text-xs"> ({typeStrategy[geo_type as keyof typeof typeStrategy]})</span>
      </p>
    );

    return ({
      label,
      filter: geo?.display_name,
      value: geo?.id,
      type: geo_type,
    });
  };

  static geoLabelTransformer = (item: GeoItem) => {
    if (!item || !item.geo) {
      return;
    }

    const { geo, geo_type } = item;

    const isCity = geo_type as keyof typeof typeStrategy === 'Geo::City';

    const label = `${geo.display_name}${isCity && geo.state.acronym ? `/${geo.state.acronym}` : ''} (${typeStrategy[geo_type as keyof typeof typeStrategy]})`

    return label
  };

  static mapToGeoOptions: () => (items?: GeoItem[]) => any[] = () => {
    return (items?: GeoItem[]) => {
      if (!items) {
        return [];
      }

      const filteredItems = items?.filter(i => i);

      if (!filteredItems || !Array.isArray(filteredItems)) {
        return [];
      }

      return this.mapToGeo()(filteredItems);
    };
  };

  static optionsTransformer() {
    return (geos: (GeoData & { state?: GeoData })[]) => {
      return geos.map((geo) => {
        if ((geo as { state?: GeoData; }).state) {
          return {
            value: geo.id,
            label: `${geo.display_name}/${(geo as { state: GeoData; }).state.acronym}`,
          };
        }

        return {
          value: geo.id,
          label: geo.display_name,
        };
      });
    };
  }

}
